import { Col, createModal, Divider, ModalProps, Row, Typography } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import clsx from "clsx";
import Modal from "ui/common/components/feedback/Modal/Modal";
import PermissionsSelector from "./PermissionsSelector/PermissionsSelector";
import { ToolbarButton } from "./CreateAdmin.styles";
import CreateAdminForm from "./CreateAdminForm/CreateAdminForm";
import type { BasicUserDto } from "common/models/api/models/BasicUserDto";
import useCreateAdminModal from "./hooks/useCreateAdminModal";

const CreateAdminModal = createModal<{ admin: BasicUserDto } & ModalProps>(({ className, admin, ...rest }) => {
    const translate = useTranslate();

    const {
        form,
        isValidForm,
        isSendingData,
        isFetchingUserData,
        handleFormChange,
        handleSubmit,
        handleIdentificationInputBlur,
        closeModal,
        isValidatingReleaseStrategy,
    } = useCreateAdminModal({ admin });

    return (
        // skipcq: JS-0415
        <Modal
            title={admin ? translate("modifyAdministrator") : translate("createAdministrator")}
            className={clsx("modify-movements-modal", className)}
            style={{ width: "700px", maxHeight: "none" }}
            {...rest}
        >
            <Col gap={20}>
                <PermissionsSelector defaultValue={form.adminPermissions} onChange={handleFormChange} />
                <Divider />
                <CreateAdminForm
                    isIdentificationLoading={isFetchingUserData}
                    onIdentificationInputBlur={handleIdentificationInputBlur}
                    form={form}
                    onChange={handleFormChange}
                />
                <Divider />
                <Row justifyContent="center" gap={15}>
                    <ToolbarButton loading={isSendingData || isValidatingReleaseStrategy} variant="outlined" onClick={closeModal}>
                        <Typography variant="body2Strong">{translate("cancel")}</Typography>
                    </ToolbarButton>
                    <ToolbarButton loading={isSendingData || isValidatingReleaseStrategy} onClick={handleSubmit} disabled={!isValidForm}>
                        <Typography variant="body2Strong">{translate("save")}</Typography>
                    </ToolbarButton>
                </Row>
            </Col>
        </Modal>
    );
});

export default CreateAdminModal;
